'use client';

import { useRouter, usePathname, useSearchParams } from 'next/navigation';

import { RouterAdapter } from '../types';

export const useAppRouterAdapter = (): RouterAdapter => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return {
    push: router.push,
    replace: router.replace,
    back: router.back,
    pathname,
    reload: router.refresh,
    isReady: true, // Next.js app router does not have an isReady property
    query: Object.fromEntries(searchParams.entries())
  };
};
